export default interface Locale {
  id: number | string;
  code: string;
  name: string;
}
